import axios from 'axios'
import config from '@/config'

const endpoint = axios.create({ baseURL: config.API_URL })

function authorizeApi (token) {
  if (token) {
    endpoint.defaults.headers.common.Authorization = `Bearer ${token}`
  } else {
    delete endpoint.defaults.headers.common.Authorization
  }
}

const api = {
  fetchData () {
    return endpoint.post('/data')
  },
  requestAccess (data) {
    return endpoint.post('/request', data)
  },
  patchDetails (data) {
    return endpoint.patch('/account', data)
  },
  adminPatchBadge (data) {
    return endpoint.patch('/admin/badge', data)
  },
  adminPatchMatch (data) {
    return endpoint.patch('/admin/match', data)
  },
  adminPatchIsAdmin (data) {
    return endpoint.patch('/admin/is-admin', data)
  },
  adminPatchCityGame (data) {
    return endpoint.patch('/admin/city-game', data)
  },
  makeOrder (data) {
    return endpoint.post('/account/order', data)
  },
  register (data) {
    return endpoint.post('/register', data)
  },
  registerCityGame (data) {
    return endpoint.post('/register/city-game', data)
  },
  registerGuest (data) {
    return endpoint.post('/register/guest', data)
  }
}

export { api, authorizeApi }
